





















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel } from "@/models/event";

@Component({})
export class Operation extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;

  get formConfig() {
    return {
      meta: {
        type: {
          label: this.$t("event.fields.type"),
          disabled: this.disabled,
        },
        establishment: {
          label: this.$t("event.fields.establishment"),
          disabled: this.disabled,
        },
        department: {
          label: this.$t("event.fields.department"),
          disabled: this.disabled,
        },
        doctorName: {
          label: this.$t("event.fields.doctorName"),
          disabled: this.disabled,
        },
        doctorComment: {
          label: this.$t("event.fields.doctorComment"),
          disabled: this.disabled,
        },
        complications: {
          label: this.$t("event.fields.complications"),
          disabled: this.disabled,
        }
      }
    };
  }
}
export default Operation;
